import {
  OperationSummaryError,
  OperationSummaryParams
} from 'components/RecordsListView/types';
import useOperationSummary from 'hooks/useOperationSummary';
import useApplication, { ApplicationSummary } from './useApplication';

interface UseApplicationsReturn {
  loading: boolean;
  applications: ApplicationSummary[];
  totalElements: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  numberOfElements: number;
  loadApplications: () => Promise<void>;
  errors?: OperationSummaryError | null;
}

const useApplications = (
  params?: OperationSummaryParams
): UseApplicationsReturn => {
  const { getApplications } = useApplication();

  const {
    loading,
    items: applications,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadItems: loadApplications,
    errors
  } = useOperationSummary<ApplicationSummary>(
    'applications',
    getApplications,
    params,
    'applications'
  );

  return {
    loading,
    applications,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadApplications,
    errors
  };
};

export default useApplications;
